import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import styled from 'styled-components';

import { State } from 'src/state/ducks';
import * as shopActions from 'src/state/ducks/shop/actions';
import * as tagActions from 'src/state/ducks/master/actions';
import * as notificationActions from 'src/state/ducks/notification/actions';
import { ShopEntity } from 'src/firebase/db/Shops';

import StyleConfig from 'src/constants/StyleConfig';
import { DefaultPageProps, HistoryProps } from 'src/constants/Interface';

import { DefaultLayout } from 'src/components/layouts/DefaultLayout';
import Heading from 'src/components/atoms/typo/Heading';
import ShopForm from 'src/components/organisms/form/ShopForm';
import SpinnerModal from 'src/components/organisms/loading/SpinnerModal';
import LoadingContainer from 'src/container/util/LoadingContainer';
import ErrorPage from 'src/container/error/ErrorPage';

type OwnProps = {
  id: string;
};

type Props = DefaultPageProps &
  HistoryProps &
  OwnProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

const ShopEditPage = (props: Props) => {
  const {
    id,
    user,
    shop,
    draft,
    tags,
    errors,
    isFetching,
    hasNotifications,
    getTags,
    getShops,
    setDraft,
    updateShop,
    fetchHasNotifications,
  } = props;

  useEffect(() => {
    getTags();
    getShops();
    fetchHasNotifications(id);
  }, [id, getTags, getShops, fetchHasNotifications]);

  useEffect(() => {
    if (shop && draft.id !== shop.id) {
      setDraft(shop);
    }
  }, [shop, draft, setDraft]);

  if (isFetching) return <LoadingContainer />;
  if (!shop) {
    return (
      <ErrorPage {...props} ownErrCode={404}>
        <div>
          <p>存在しない店舗です</p>
        </div>
      </ErrorPage>
    );
  }

  return (
    <DefaultLayout {...props}>
      <Block>
        <SpinnerModal isLoading={isFetching} />
        <Heading text={'店舗基本情報を編集する'} />
        <ShopForm
          formType="UPDATE"
          onSubmit={updateShop}
          tags={tags}
          shop={draft}
          role={user.role}
          hasNotifications={hasNotifications}
          errors={errors}
        />
      </Block>
    </DefaultLayout>
  );
};
// class ShopEditPage extends Component<Props> {
//   componentDidMount() {
//     this.props.getTags();
//     this.props.getShops();
//     console.log(this.props);
//   }

//   componentDidUpdate() {
//     if (this.props.shop && this.props.draft.id !== this.props.shop.id) {
//       this.props.setDraft(this.props.shop);
//     }
//   }

//   render() {
//     const { shop, draft, isFetching, tags, updateShop, errors } = this.props;
//     if (isFetching) return <LoadingContainer />;
//     if (!shop) {
//       return (
//         <ErrorPage {...this.props} ownErrCode={404}>
//           <div>
//             <p>存在しない店舗です</p>
//           </div>
//         </ErrorPage>
//       );
//     }
//     return (
//       <DefaultLayout {...this.props}>
//         <Block>
//           <SpinnerModal isLoading={isFetching} />
//           <Heading text={'店舗基本情報を編集する'} />
//           <ShopForm
//             formType="UPDATE"
//             onSubmit={updateShop}
//             tags={tags}
//             errors={errors}
//             shop={draft}
//             role={this.props.user.role}
//           />
//         </Block>
//       </DefaultLayout>
//     );
//   }
// }

const Block = styled.div`
  box-sizing: border-box;
  padding: ${StyleConfig.HELPER.M20};
`;

const mapStateToProps = (state: State, OwnProps: OwnProps) => ({
  tags: state.master.tags,
  shop: state.shop.resource.find((shop) => shop.id === OwnProps.id),
  draft: state.shop.draft,
  hasNotifications: state.notification.isNotified,
  errors: state.shop.validationErrors,
  isFetching: state.master.isFetching || state.shop.isFetching,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getTags: () => dispatch(tagActions.getTags()),
  setDraft: (payload?: ShopEntity) => dispatch(shopActions.setDraft(payload)),
  getShops: () => dispatch(shopActions.getShops()),
  updateShop: (query: ShopEntity) => dispatch(shopActions.updateShop(query)),
  fetchHasNotifications: (shopId: string) =>
    dispatch(notificationActions.hasNotifications({ shopId })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShopEditPage);
